import { useJobs } from "src/jobs/api/queries";

/**
 * As of 09/25 a simulation service job is created together with the first simulation dataset of a flow.
 * @returns the simulation job for the current flow
 */
export const useSimulationJob = (flowId: string, baseUrl: string) => {
  const { data: jobs, isLoading } = useJobs(
    baseUrl,
    flowId,
    null,
    undefined,
    true,
  );

  return {
    simulationJob: jobs?.find((job) => job.tags?.simulation === true),
    isLoading,
  };
};
